import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { getCheapestInsights } from "@/lib/cheapestPrices.functions";

const ElPriserMain = lazy(() => import("@/pages/ElPriserMain"));

export const Route = createFileRoute("/elpriser/")({
  loader: () => getCheapestInsights(),
  head: () =>
    seoHead("/elpriser", {
      description:
        "Elpriser idag och imorgon för SE1–SE4. Se när elen är billigast idag, billigaste timmen imorgon och historiskt billigaste månaden – direkt ur spotprisdata.",
    }),
  component: ElPriserRoute,
});

function ElPriserRoute() {
  const insights = Route.useLoaderData();
  return <ElPriserMain insights={insights ?? null} />;
}
